import ProfileVerificationStatusCd from 'domain/enums/ProfileVerificationStatusCd';
import ChsAttachment from 'domain/types/ChsAttachment';
import ProfileVerification from 'domain/types/ProfileVerificationStatus';

function hasUploadedIdentity(
  identity: ChsAttachment | null,
  status: ProfileVerification | null
) {
  if (!identity || !status) {
    return false;
  }
  return status.statusCd !== ProfileVerificationStatusCd.INITIAL;
}

export default hasUploadedIdentity;
